import { render, staticRenderFns } from "./DataCrossTable.vue?vue&type=template&id=644fee92&scoped=true&"
import script from "./DataCrossTable.vue?vue&type=script&lang=js&"
export * from "./DataCrossTable.vue?vue&type=script&lang=js&"
import style0 from "./DataCrossTable.vue?vue&type=style&index=0&id=644fee92&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "644fee92",
  null
  
)

export default component.exports